export const QuestNames = ['hvac-quest', 'solar-quest', 'storage-quest'] as const;
export type QuestName = (typeof QuestNames)[number];

export const TaskNames = [...QuestNames] as const;
export type TaskName = (typeof TaskNames)[number];

export const TaskTypes = ['quest'] as const;
export type TaskType = (typeof TaskTypes)[number];

export const TaskRewardTypes = ['coupon', 'points'] as const;
export type TaskRewardType = (typeof TaskRewardTypes)[number];
